import React from "react"

import { getView } from "@/onboarding/features/product/components/product_components/views/EditWrapper"
import { useAuthDescriptor } from "@/auth_descriptor/hooks"
import { CRUISE_LINE_FIELD_PLACEHOLDER } from "@/onboarding/features/product/models/Product"

const ComponentDisplay = ({ component }): JSX.Element => {
  const { isTourUi } = useAuthDescriptor()
  const View = getView(component)

  const referencedValueMessage = isTourUi ? CRUISE_LINE_FIELD_PLACEHOLDER : ""

  return (
    <View component={component} editing hideRates referencedValueMessage={referencedValueMessage} />
  )
}

export default ComponentDisplay
